module.exports = __webpack_public_path__ + "img/profitAndLoss-sm.c10c4b0f.svg";